import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projects: (Identifiable<Project> & {
    zone: Identifiable<Zone>;
  })[];
  retrieveZonesProjects(
    request: Boundaries["retrieveZonesProjects"]["request"],
  ): void;
}

function useZonesProjectsRetrieval(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isZonesProjectsRetrievalRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isZonesProjectsRetrievalRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isZonesProjectsRetrievalRequestFailure,
    ),
    projects: useSelector(selector.getZonesProjects),
    retrieveZonesProjects: core.retrieveZonesProjects,
  };
}

export { useZonesProjectsRetrieval };
